import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "screen nextlevel-screen" }
const _hoisted_2 = { class: "nextlevel-screen-header" }
const _hoisted_3 = { class: "nextlevel-screen-stars" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "nextlevel-screen-star star1 mdi mdi-star" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "nextlevel-screen-star star2 mdi mdi-star"
}
const _hoisted_6 = {
  key: 1,
  class: "nextlevel-screen-star star3 mdi mdi-star"
}
const _hoisted_7 = { class: "nextlevel-screen-title" }
const _hoisted_8 = { class: "nextlevel-screen-level" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-play" }, null, -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "nextlevel-screen-main" }
const _hoisted_12 = { class: "nextlevel-screen-footer" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-motion-play-outline" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-exit-to-app" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_countdown = _resolveComponent("countdown")!
  const _component_logo = _resolveComponent("logo")!
  const _component_players_table = _resolveComponent("players-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.countdownStarted)
      ? (_openBlock(), _createBlock(_component_countdown, {
          key: 0,
          onExpired: _ctx.startGame,
          from: 3
        }, null, 8, ["onExpired"]))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_logo),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.stars >= 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.stars == 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.$t('levelComplete')) + " ", 1),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('nextLevel')) + ": " + _toDisplayString(_ctx.nextLevel) + " ", 1),
          (_ctx.$store.state.bestLevel < _ctx.$store.state.gameState.lvlNumber)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('newBestLevel')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_11, [
      _createVNode(_component_players_table)
    ]),
    _createElementVNode("footer", _hoisted_12, [
      _createElementVNode("button", {
        class: "nextlevel-screen-next",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startCountdown && _ctx.startCountdown(...args)))
      }, [
        _hoisted_13,
        _createTextVNode(_toDisplayString(_ctx.$t('next')) + " (" + _toDisplayString(_ctx.autoStartCountdown) + ")", 1)
      ]),
      _createElementVNode("button", {
        class: "nextlevel-screen-exit",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exit && _ctx.exit(...args)))
      }, [
        _hoisted_14,
        _createTextVNode(_toDisplayString(_ctx.$t('exit')), 1)
      ])
    ])
  ]))
}